var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebhook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.32H8.00667C7.27333 11.32 6.70667 11.9467 6.35333 12.5867C6.07364 13.1115 5.62653 13.5278 5.08308 13.7693C4.53964 14.0109 3.93104 14.0638 3.35405 13.9197C2.77705 13.7757 2.26477 13.4429 1.89863 12.9743C1.5325 12.5056 1.33352 11.928 1.33333 11.3333C1.34 10.8667 1.46667 10.4 1.71333 10",
  stroke: "currentColor",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 11.3331L6.08667 7.47978C6.44 6.83312 6.15333 6.02645 5.75333 5.41312C5.56454 5.11119 5.43814 4.7745 5.38157 4.42292C5.32501 4.07135 5.33943 3.71201 5.42399 3.36609C5.50855 3.02018 5.66154 2.69471 5.87392 2.40888C6.08631 2.12306 6.35379 1.88266 6.66058 1.70188C6.96737 1.5211 7.30727 1.40359 7.66021 1.3563C8.01315 1.309 8.37199 1.33287 8.71556 1.42651C9.05912 1.52014 9.38046 1.68164 9.6606 1.90146C9.94074 2.12129 10.174 2.39501 10.3467 2.70645",
  stroke: "currentColor",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4L10.0867 7.82C10.44 8.46667 11.2667 8.66667 12 8.66667C12.7072 8.66667 13.3855 8.94762 13.8856 9.44772C14.3857 9.94781 14.6667 10.6261 14.6667 11.3333C14.6667 12.0406 14.3857 12.7189 13.8856 13.219C13.3855 13.719 12.7072 14 12 14",
  stroke: "currentColor",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgWebhook;